import { Box } from "@mui/material";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { EducationCategories } from "../../constants";

const EduColumnBottom = ({ onHitBottom, categoryIdx }) => {
  const edu = useSelector((state) => state.edu);
  const handleScroll = useCallback((node) => {
    if (node) {
      const observer = new IntersectionObserver(
        (entries) => {
          const tag =
            categoryIdx === 0 ? "all" : EducationCategories[categoryIdx];
          if (
            edu.txtPanels &&
            edu.counts[tag] &&
            edu.txtPanels.length >= edu.counts[tag]
          ) {
            return;
          }
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              onHitBottom();
            }
            // } else {
            //   console.log("not bottom of edu column");
            //   setIsVisible(false);
            // }
          });
        },
        {
          threshold: 1.0,
        }
      );
      observer.observe(node);
    }
  });

  return (
    <Box
      ref={handleScroll}
      sx={{
        width: 0,
        height: "1px",
      }}
    />
  );
};

export default EduColumnBottom;
